import CurrentVersion from "tm:tmng_version_hash";


const handlers: ((pre: string, post: string)=>void)[] = [];


async function getCurrentVersion() {
    const response = await fetch("/static-data/version", {
        mode: "same-origin"
    });
    const {version} = await response.json()
    return version;
}


let triggered = null as string|null;
let first = true;
const interval = setInterval(() => {
    /*
    if (first) {
        console.debug("[Update] Skipping first run");
        first = false;
        return;
    }
    */

    (async () => {
        const remoteVersion = await getCurrentVersion();
        if (remoteVersion !== CurrentVersion) {
            triggered = remoteVersion;
            handlers.forEach((f) => f(CurrentVersion, remoteVersion));
            clearInterval(interval);
        }
    })().catch((error) => {
        // A temporary network failure is not an application exception. The
        // interval retries the check on its next tick.
        console.warn("[Update] Version check failed; retrying later.", error);
    });
}, 60000);
console.log("[Update] Version-Checker Started");


export function addHandler(handler: (pre: string, post: string) => void) {
    if (triggered !== null) {
        handler(CurrentVersion, triggered);
        return;
    }

    handlers.push(handler);
}


export function hasRemoteUpdate(): boolean {
    return triggered !== null;
}


addHandler((from, to) => console.log(`[Update] Update detected: Version ${from} => ${to}`));
